import { render, staticRenderFns } from "./dev.vue?vue&type=template&id=49499eb7&"
import script from "./dev.vue?vue&type=script&lang=js&"
export * from "./dev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports